import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigService } from '@kempower-nx-workspace/receipt-lookup-environment';
import { ReceiptsApiServiceObservable } from '@kempoweroyj/ngx-receipts-api-client';
import { ReceiptSearchService } from '@kempower-nx-workspace/receipt-lookup-page';
import { BrandingApiServiceObservable } from '@kempoweroyj/ngx-branding-api-client';
import { BrandingService } from '@kempower-nx-workspace/receipt-lookup-app-core';

@Component({
    standalone: true,
    imports: [RouterModule],
    providers: [ReceiptsApiServiceObservable, ReceiptSearchService, BrandingApiServiceObservable, BrandingService],
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    title = 'receipt-lookup';
    readonly configService = inject(ConfigService);
}
